"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createTheme = _interopRequireDefault(require("./createTheme"));
const defaultTheme = (0, _createTheme.default)();
var _default = defaultTheme;
exports.default = _default;